module.exports = __webpack_public_path__ + "media/applicants/plus-8b3c3859.svg";